var version = {
    "name":      "dativery",
    "buildDateCode": "20260309-142518",
    "buildDate": "Mon Mar 09 2026 14:25:18 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260309-142518",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;